// extracted by mini-css-extract-plugin
export default {"content":"style_content__KnhDO","itemName":"style_itemName__5x5iL","leftSide":"style_leftSide__yIt7W","rightSide":"style_rightSide__xRJQO","type":"style_type__gD--A"};